export class ChallengeService {
  RANK_SCORE_TABLE = [0, 100, 400, 600, 800, 1000, 1200, 1500, 2000]

  RANK_NAME_TABLE = [
    'ニワトリ級', // アイアン
    'コアラ級', // ブロンズ
    'ブタ級', // シルバー
    'ゾウ級', // ゴールド
    'クマ級', // プラチナ
    'ネコ級', // ダイアモンド
    'ウサギ級', // マスター
    'ウマ級', // グランドマスター
    'チーター級' // チャレンジャー
  ]

  getRank(score) {
    let rankIndex = 0
    this.RANK_SCORE_TABLE.forEach((rangeStart, i) => {
      const rangeEnd = this.RANK_SCORE_TABLE[i + 1]
        ? this.RANK_SCORE_TABLE[i + 1]
        : 10000
      if (score >= rangeStart && score < rangeEnd) {
        rankIndex = i
      }
    })
    return rankIndex
  }

  getRankName(rankIndex) {
    return this.RANK_NAME_TABLE[rankIndex]
  }
}

export default new ChallengeService()